import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Password from '../../fields/Password';
import { useSelector } from 'react-redux';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import LoadingBars from '../../elements/LoadingBars';

export default function SetPasswordFileForm({ handleSubmit, handledClose, isLoading }) {
  const { values } = useSelector((state) => state.form.formSetPasswordFile);
  const [stragth, setStragth] = React.useState(0);

  const onSubmit = async (e) => {
    e.preventDefault();
    handleSubmit(values);
  };
  return(
    <form onSubmit={onSubmit}>
      <Field
        component={Password}
        inputProps={{
          icon: 'ic-lock.svg',
          label: 'Kata Sandi',
          info: 'Ingat atau amankan kata sandi, karena akan digunakan untuk membuka file',
          placeholder: 'Masukkan kata sandi file data',
        }}
        name={'password'}
        setStrength={setStragth}
        strength={stragth}
        withStrength={true}/>

      <div className={styles.containerBtn}>
        <Button onClick={handledClose} style={'outlined'}type={'button'}>Batal</Button>
        <Button
          className={styles.btn}
          disabled={stragth < 5 || isLoading}
          style={'blue'}
          type={'submit'}>
          {isLoading && <LoadingBars size={1} />}
          Set Kata Sandi dan Unduh Data</Button>
      </div>
    </form>
  );
}

SetPasswordFileForm.propTypes = {
  handledClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
};
